import { HStack, Text, VStack, Icon, Tooltip } from '@chakra-ui/react';
import React from 'react';
import { ReportingViewBaseConfig } from '../../../base';
import { RecordFormViewProps } from './recordFormProps';
import { ValueFieldContainerProps } from '../../common/value/field';

export function createRecordFormView(
    config: ReportingViewBaseConfig & {
        Container: {
            Value: React.FC<ValueFieldContainerProps>;
        };
    }
): React.FC<RecordFormViewProps> {
    const {
        Container: { Value: ValueContainer },
    } = config;

    return (props) => {
        return (
            <VStack align="start" w="full" spacing={1}>
                {props.property.items.map((item) => (
                    <HStack key={item.id} w="full" spacing={2} align="start">
                        <Tooltip
                            placement="top"
                            openDelay={300}
                            px={2}
                            py={1}
                            bg="gray.50"
                            borderRadius="md"
                            color="gray.900"
                            label={item.description}
                            isDisabled={!item.description}
                        >
                            <HStack
                                userSelect="none"
                                px={3}
                                py={2}
                                minW="12rem"
                                flexShrink={0}
                                _hover={{ bg: 'whiteAlpha.50' }}
                                borderRadius="md"
                                fontWeight="medium"
                                color="whiteAlpha.600"
                                spacing={3}
                            >
                                <Icon fontSize="lg" as={item.Icon} />
                                <Text noOfLines={1}>{item.label}</Text>
                            </HStack>
                        </Tooltip>

                        <HStack w="full" flex="1 1 auto" minW={0}>
                            <ValueContainer {...item.value} />
                        </HStack>
                    </HStack>
                ))}
            </VStack>
        );
    };
}
